import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ReplaySubject, zip } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomerService } from 'modules/core/services/customer.service';
import { DocumentsService } from 'modules/core/services/documents.service';
import { TasksService } from '../../services/tasks.service';
import { environment } from 'environments/environment';
var DashboardPage = /** @class */ (function () {
    function DashboardPage(tasksService, cdRef, customersService, documentsService) {
        this.tasksService = tasksService;
        this.cdRef = cdRef;
        this.customersService = customersService;
        this.documentsService = documentsService;
        this.unsubscribe$ = new ReplaySubject(1);
        this.enableHandshakes = environment['ENABLE_HANDSHAKES'];
        this.enableOpenCorporates = environment['ENABLE_OPENCORPORATES'];
    }
    DashboardPage.prototype.ngOnInit = function () {
        this.getTasksStats();
    };
    DashboardPage.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    /**
     * Get stats for populating donut chart
     * @method getTasksStats
     */
    DashboardPage.prototype.getTasksStats = function () {
        var _this = this;
        zip(this.tasksService.getTasks('PENDING'), this.tasksService.getTasks('OVERDUE'), this.customersService.loadPeriodicReview(), this.documentsService.getDocuments({ show_expiry_alerts: true, expiring: true }))
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (_a) {
            var pendingTaskRes = _a[0], overdueTaskRes = _a[1], periodicReviewRes = _a[2], documentsRes = _a[3];
            _this.pendingTasks = pendingTaskRes.results;
            _this.overdueTasks = overdueTaskRes.results;
            _this.stats = {
                expiringDocCount: documentsRes.count,
                ongoingDueDiligenceCount: periodicReviewRes.count,
                pendingTaskCount: pendingTaskRes.count,
                overdueTaskCount: overdueTaskRes.count
            };
            _this.cdRef.detectChanges();
        });
    };
    return DashboardPage;
}());
export { DashboardPage };
